
// Get all room price data - this is done by a collection list element creating:
// < script type="application/json" class="room-price-data"> 
// {
//   "roomSlug": "",
//   "editionSlug": "",
//   "basePriceWeek": ,
//   "basePriceMonth": ,
//   "discountMonth2": ,
//   "discountMonth3":
// }
// </ script > 
export function getAllRoomPrices(editionSlugFilter) {
  const priceElements = document.querySelectorAll('.room-price-data');
  const roomPrices = Array.from(priceElements).map(x => JSON.parse(x.textContent));
  if (!editionSlugFilter) {
  	return roomPrices;
  }
  return roomPrices.filter((x) => x.editionSlug === editionSlugFilter)
}

// calculate month difference while 1 month is always 30 days
export function getMonthDifference(startDate, endDate) {
  if (!startDate || !endDate) return 0;
  return Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24 * 30)); 
}

export function formatPrice(price, currency) {
	// That’s the locale for German, which uses the formatting style we’re after. 
  // We could also use 'fr-FR', 'it-IT', etc. — most European locales format this way.
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
  	currency,
    currencyDisplay: 'code'
  }).format(price);
}

export function parseDecimalFromString(price, defaultValue = null) {
  return !isNaN(parseFloat(price))
    ? parseFloat(price)
    : defaultValue; 
}
